import { render, staticRenderFns } from "./returns_exchanges.vue?vue&type=template&id=33f5c8b4&scoped=true&"
import script from "./returns_exchanges.vue?vue&type=script&lang=js&"
export * from "./returns_exchanges.vue?vue&type=script&lang=js&"
import style0 from "./returns_exchanges.vue?vue&type=style&index=0&id=33f5c8b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f5c8b4",
  null
  
)

export default component.exports